const config = {
    pagination: false,
    rowSelection: false,
    fieldControl: false,
    search: false,
    columns: [
        {
            title: '标记编码',
            width: 150,
            dataIndex: 'markCode'
        },
        {
            title: '标记名称',
            width: 150,
            dataIndex: 'markName'
        },
        {
            title: '状态',
            width: 150,
            dataIndex: 'enableFlag',
            render: 'enableRender',
        },
        {
            title: '操作',
            width: 150,
            fixed: 'right',
            render: 'actionRender'
        },
    ],
    // footer: [
    //     {
    //         label: "新增",
    //         type: "primary",
    //         events: ["onClick:onAdd"]
    //     },
    // ]
};

export default config
